// @flow
import range from 'lodash/range';
import { connect } from 'react-redux';

import * as selectors from '../../../reducers';
import WeekSchedule from '../../WeekSchedule';


export default connect(
  (state, { occupiedDays, value = [], routeWeekDays }) => {

    return {
      disabledWeekDays: (
        range(7)
          .filter(
            day => !(routeWeekDays || []).includes(day),
          )
      ),
      conflictedWeekDays: [],
    };
  },
  undefined,
)(WeekSchedule);



// WEBPACK FOOTER //
// ./src/scripts/components/StudentStopsScheduling/ScheduleTable/routeStopWeekSchedule.jsx